import CartaId from '../../entities/CartaId';

export class UpdateSubscriptionModel {
	subscriptionId?: number;
	
	selectedL3GlobalId?: string;

	selectedL4GlobalId?: string;

	organizationGlobalId?: string;

	environment?: number;

	platformManagementGroup: string;

	serviceEnvironment: string;

	cartaIds?: CartaId[];

	isProject?: boolean;

	wpmCode?: number;

	closeOutDate?: string;

	isConnected?: boolean;

	amountOfDevices?: number;

	region?: string;

	contributorAccessGroupId?: string;

	initialResourceGroup?: string;

	ownerUserId?: string;

	custodianUserId?: string;

	custodianTwoUserId?: string;

	subscriptionUsedFor: string;

	constructor(obj: any) {
		Object.assign(this, obj);
	}
}